import { createAction, props } from '@ngrx/store'
import { feedbackAPIModel } from 'src/app/models/api.model'

const actionPrefix = '[feedback]'

export const save_feedback_action = createAction(
  `${actionPrefix} save_feedback_action`,
  props<{ feedback: feedbackAPIModel }>()
)

export const save_feedback_success_action = createAction(
  `${actionPrefix} save_feedback_success_action`,
  props<{ feedback: feedbackAPIModel }>()
)
